import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { UpdateProvider } from 'src/app/providers/update/update.provider';
import { AccessCodePopoverComponent } from '../access-code-popover/access-code-popover.component';
import { NavController, PopoverController } from '@ionic/angular';
import { Common } from 'src/app/lib/common';
import { EventService } from '../../services/event.service';
// import { EventMessages } from 'src/app/providers/state/state.provider'
import { MessagePopoverComponent } from '../message-popover/message-popover.component';
import { TeacherProvider } from '../../providers/teacher/teacher.provider'
import { Teacher } from '../../models/teacher'
import { Page } from '../../models/page'
import { Article } from '../../models/article'
import { UserStore } from 'src/app/stores/user.store';
import { Subject, map, takeUntil } from 'rxjs';
import { TeacherStore } from 'src/app/stores/teacher.store';
import { CookieService } from 'ngx-cookie-service';

export interface Dismissable {
    dismiss(): void
}

@Injectable()
export class PageHeaderCommands {

    private teacher: Teacher
    ngUnsubscribeTeacher = new Subject<void>();

    constructor(private router: Router,
        private location: Location,
        private popoverCtrl: PopoverController,
        private updateProvider: UpdateProvider,
        private userStore: UserStore,
        private teacherStore: TeacherStore,
        private teacherProvider: TeacherProvider,
        private cookieService: CookieService) {

            this.teacher = this.teacherProvider.teacher;
            this.teacherStore.state$
                .pipe(takeUntil(this.ngUnsubscribeTeacher))
                .subscribe(() => {
                  this.teacher = this.teacherProvider.teacher;
                });
    }

    get updateAvailable(): boolean {
        return this.updateProvider.hasUpdate
    }

    update() {
        this.updateProvider.activateUpdate()
    }

    gotoMusicTogether(dismissable: Dismissable = null) {
        if (dismissable) {
            dismissable.dismiss()
        }
        window.open('https://www.musictogether.com/', '_blank')
    }

    ngOnDestroy(){
        this.ngUnsubscribeTeacher.next();
        this.ngUnsubscribeTeacher.complete();
      }

    gotoFacebook(dismissable: Dismissable = null) {
        if (dismissable) {
            dismissable.dismiss()
        }
        window.open('https://www.facebook.com/groups/1525195257704280/', '_blank')
    }

    feedback(dismissable: Dismissable = null) {
        if (dismissable) {
            dismissable.dismiss()
        }
        window.open('mailto:support@musictogether.com?subject=Contact', '_self')
    }

    gotoLessonPlansPage(dismissable: Dismissable = null) {
        if (dismissable) {
            dismissable.dismiss()
        }
        this.router.navigateByUrl('lesson-plans')
    }

    gotoPagesPage(dismissable: Dismissable = null, page: Page = null) {
        if (dismissable) {
            dismissable.dismiss()
        }
        this.router.navigateByUrl('pages/' + page.slug)
    }

    gotoResourcesPage(dismissable: Dismissable = null) {
        if (dismissable) {
            dismissable.dismiss()
        }
        this.router.navigateByUrl('teaching-tools')
    }

    gotoVideoLibraryPage(dismissable: Dismissable = null) {
        if (dismissable) {
            dismissable.dismiss()
        }
        this.router.navigateByUrl('video-library');
    }

    gotoParentEducationPage(dismissable: Dismissable = null) {
        if (dismissable) {
            dismissable.dismiss()
        }
        this.router.navigateByUrl('parent-education');
    }

    gotoTeacherNotesPage(dismissable: Dismissable = null) {
        if (dismissable) {
            dismissable.dismiss()
        }
        this.router.navigateByUrl('teacher-notes');
    }

    gotoTeachingToolsPage(dismissable: Dismissable = null) {
        if (dismissable) {
            dismissable.dismiss()
        }
        this.router.navigateByUrl('teaching-tools');
    }

    gotoBlogPage(dismissable: Dismissable = null) {
        if (dismissable) {
            dismissable.dismiss()
        }
        this.router.navigateByUrl('blog');
    }

    gotoArticle(dismissable: Dismissable = null, article: Article) {
        if (dismissable) {
            dismissable.dismiss()
        }
        this.router.navigateByUrl('blog/' + article.slug);
    }

    gotoTrainingPage(dismissable: Dismissable = null) {
        if (dismissable) {
            dismissable.dismiss()
        }
        this.router.navigateByUrl('training');
    }

    popPage(backName: string) {
        if (backName == 'Lesson Plans') {
            return this.gotoLessonPlansPage()
        }
        this.location.back();
    }

    enterAccessCode(dismissable: Dismissable = null) {
        if (dismissable) {
            dismissable.dismiss()
        }

        setTimeout(() => {
            this.popoverCtrl.create({
                component: AccessCodePopoverComponent,
                cssClass: 'access-code-popover'
            }).then(popover => {
                popover.present().then(() => Common.ensurePopoverOnScreen())
            })
        }, 500)
    }

    reloadApp(dismissable: Dismissable = null) {
        if (dismissable) {
            dismissable.dismiss()
        }

        // We have to wait just a little after the dismiss or message popover doesn't show
        setTimeout(() => {
            MessagePopoverComponent.present(this.popoverCtrl, 'Reloading', 'The latest version of the app is loading.', false, false, [])
        }, 100)

        // Give time for the message to be read
        setTimeout(() => {
            // Kill the caches before reloading
            // window.caches.keys().then((values: string[]) => {
            //     values.forEach((value: string, index: number) => {
            //         window.caches.delete(value).then()
            //     })

            //     this.updateProvider.activateUpdate()
            // })
            this.updateProvider.activateUpdate()
        }, 2000)
    }

    logout(dismissable: Dismissable = null) {
        // #280 -- John commented out for now. Need to implement differently.
        // if ((this.teacher.coursesBeingEdited.size > 0 || this.teacher.lessonsBeingEdited.size > 0) &&
        //     !confirm('You have unsaved edits, these will be lost if you log out. Are you sure you want to log out?')) {
        //     if (dismissable) {
        //         dismissable.dismiss()
        //     }
        // } else {

            if (dismissable) {
                dismissable.dismiss()
            }

            this.userStore.logoutUser()
            this.cookieService.delete('cache-notification-closed')
            let req = indexedDB.deleteDatabase("_ionicstorage")      
            req.onsuccess = () =>{
                // console.log("Deleted database successfully");
            };
            req.onerror = () => {
                // console.log("Couldn't delete database");
            };     
            this.router.navigateByUrl('login').then(() => {
                
            })

            
    }
}
